module.exports = __webpack_public_path__ + "img/cards2_back7.11f48eb4.png";